import { useAuth } from '@/hooks/useAuth'

/**
 * Placeholder landing for the ABANCA staff surface (`/app/*`).
 *
 * The route is protected: an unauthenticated visit redirects to `/login` and
 * returns here after the Cognito hosted-UI login. Real staff screens replace
 * this scaffold later.
 */
export function AppSurfacePage() {
	const { user } = useAuth()

	return (
		<div className="space-y-6">
			<div>
				<h1 className="text-2xl font-bold text-ds-text">ABANCA — App</h1>
				<p className="text-sm text-ds-text-muted mt-1">
					Staff workspace{user ? `, ${user.displayName || user.email}` : ''}.
				</p>
			</div>

			<div className="rounded-lg border border-dashed border-ds-border-strong p-8 text-center">
				<p className="text-sm text-ds-text-muted">ABANCA staff surface. Scaffold — replace with staff screens.</p>
			</div>
		</div>
	)
}
